import React from 'react';
import GenericSvgIcon from "./GenericSvgIcon";
import IconType from "@/types/Icon.type";

function IconPhone(props: IconType) {
    const {
        width = '16',
        height = '16',
        fill = "#7e00d9",
        viewBox = '0 0 16 16',
        title = 'IconPhone',
        ...rest
    } = props

    return (
        <GenericSvgIcon
            width={width}
            height={height}
            fill={fill}
            viewBox={viewBox}
            title={title}
            {...rest}
            svgIconPath={(
                <path
                    d="m4.23357201 0c.20886304 0 .402697.10861532.51173938.28675439l1.80031276 2.9411136c.1776765.29026443.07861855.67003673-.21819814.83653668l-1.23930031.69459533 1.91077224 2.90079433-1.00225094.65991898-2.26420045-3.43875096c-.19145843-.29077719-.09605451-.68292377.20758423-.85325056l1.25609492-.70571179-1.299-2.122h-2.571l.0046942.01739785c.04110731.18780954.08750593.38538622.13944217.59140001l.08208838.31518228c.32864972 1.22307122.77149162 2.44552448 1.34244357 3.58156884.62923557 1.25201346 1.37656175 2.31965921 2.24745622 3.14755911.59382366.56450761 1.25178186 1.06330095 1.96349418 1.50016551 1.17430582.7208146 2.43673077 1.2415397 3.69940528 1.5928817.4415101.1228511.850661.2155754 1.2163637.2822705l-.2263877-.0444258v-2.34l-1.729-1.101-.75987241.70086697-.81286616-.88275059 1.09980581-1.01273785c.20011846-.18427575.49917436-.21085474.72865486-.06476018l2.3957932 1.52523746c.1730137.11014592.2777782.30103589.2777782.50613547v3.37893042c0 .3574542-.3105867.6356206-.6658797.5963723-.1011435-.0111731-.2791934-.0368166-.5233251-.0813402-.4004082-.0730245-.8449236-.1737633-1.3227465-.3067186-1.3639912-.3795336-2.72823192-.9422557-4.00548074-1.7262589-.7810969-.4794543-1.50583552-1.0288734-2.16252502-1.65314329-.98035499-.93195654-1.80558849-2.11090231-2.49287242-3.47841675-.61088997-1.21551053-1.08076223-2.51258037-1.42912996-3.80903226-.12188521-.45359626-.22002604-.87529291-.29663082-1.25473399-.04649465-.23029868-.07574755-.397305-.08990983-.49061703-.05510629-.36308263.22596593-.69003298.59320659-.69003298z"
                    fill={fill} transform="translate(1.5022 1.253)"
                />
            )}
        />

    );
}

export default IconPhone;
